import { redirect } from '@tanstack/react-router';
import { Schema } from 'effect';
// oxlint-disable-next-line server-fn/no-create-server-fn -- SSR routing logic (static redirect map, no server deps)
import { createServerFn } from '@tanstack/react-start';

const redirects: Record<string, string> = {
  '/app_pdf': '/app',
  '/app-pdf': '/app',
  '/sgu':
    '/podcast?utm_source=host_read_podcasts&utm_medium=podcast&utm_campaign=skeptics_guide&utm_content=round_1&podcastName=The%20Skeptics%20Guide%20to%20the%20Universe',
  '/bps':
    '/podcast?utm_source=host_read_podcasts&utm_medium=podcast&utm_campaign=big_picture_science&utm_content=round_1&podcastName=Big%20Picture%20Science',
  '/gettingin':
    '/podcast?utm_source=host_read_podcasts&utm_medium=podcast&utm_campaign=college_coach&utm_content=round_1&podcastName=Getting%20In',
  '/vbw':
    '/podcast?utm_source=host_read_podcasts&utm_medium=podcast&utm_campaign=very_bad_wizards&utm_content=round_1&podcastName=Very%20Bad%20Wizards',
  '/lockedon':
    '/podcast?utm_source=host_read_podcasts&utm_medium=podcast&utm_campaign=locked_on_sports&utm_content=round_1&podcastName=LockedOn%20College%20Sports',
  '/blackfriday': '/',
  '/blackfriday-depracated': '/',
  '/caricanread':
    '/youtube?utm_source=long_form&utm_medium=youtube_influencer&utm_campaign=cari_can_read&utm_content=video',
  '/jackinthebooks':
    '/youtube?utm_source=long_form&utm_medium=youtube_influencer&utm_campaign=jack_in_the_books&utm_content=video',
  '/jack-in-the-books':
    '/youtube?utm_source=long_form&utm_medium=youtube_influencer&utm_campaign=jack_in_the_books&utm_content=video',
  '/tarenstudies':
    '/three-week-trial?utm_source=tiktok&utm_medium=tiktok&utm_campaign=tarenstudies&utm_content=video',
  '/rileyxchong':
    '/three-week-trial?utm_source=tiktok&utm_medium=tiktok&utm_campaign=rileyxchong&utm_content=video',
  '/the_lab_life1':
    '/three-week-trial?utm_source=instagram&utm_medium=instagram&utm_campaign=the_lab_life1&utm_content=video',
  '/dr.alexahecht':
    '/three-week-trial?utm_source=instagram&utm_medium=instagram&utm_campaign=dr.alexahecht&utm_content=video',
  '/weareallengineers':
    '/three-week-trial?utm_source=instagram&utm_medium=instagram&utm_campaign=weareallengineers&utm_content=video',
  '/kristinavirro':
    '/three-week-trial?utm_source=instagram&utm_medium=instagram&utm_campaign=kristinavirro&utm_content=video',
  '/nurse_gabs_':
    '/three-week-trial?utm_source=instagram&utm_medium=instagram&utm_campaign=nurse_gabs_&utm_content=video',
  '/notesonhumanity':
    '/three-week-trial?utm_source=instagram&utm_medium=instagram&utm_campaign=notesonhumanity&utm_content=video',
  '/rubygranger':
    '/youtube?utm_source=long_form&utm_medium=youtube_influencer&utm_campaign=rubygranger&utm_content=video',
  '/studytosuccess':
    '/youtube?utm_source=long_form&utm_medium=youtube_influencer&utm_campaign=studytosuccess&utm_content=video',
  '/study-to-success':
    '/youtube?utm_source=long_form&utm_medium=youtube_influencer&utm_campaign=studytosuccess&utm_content=video',
  '/eleanorneale':
    '/youtube?utm_source=long_form&utm_medium=youtube_influencer&utm_campaign=eleanorneale&utm_content=video',
  '/tamkaur':
    '/youtube?utm_source=long_form&utm_medium=youtube_influencer&utm_campaign=tamkaur&utm_content=video',
  '/amycheah':
    '/youtube?utm_source=long_form&utm_medium=youtube_influencer&utm_campaign=amycheah&utm_content=video',
  '/macerly':
    '/youtube?utm_source=long_form&utm_medium=youtube_influencer&utm_campaign=macerly&utm_content=video',
  '/academic-old': '/academic',
  // Retired hand-rolled promo pages (pricing-experiment doc, D24)
  '/back2school': '/pricing',
  '/study-smarter': '/pricing',
  '/learn': '/',
  '/learn/how-long-to-write-a-research-paper': '/',
  '/survey': '/',
  '/espanol': '/es',
  '/de/create-your-account': '/',

  '/fb/create-your-account': '/',
  '/fr/create-your-account': '/',
  '/it/create-your-account': '/',
  '/pt/create-your-account': '/',
  '/1440': '/',
  '/annual-test-create-account': '/',
  '/checkout': '/',
  '/create-your-account': '/',
  '/darkhorse': '/',
  '/deep': '/',
  '/findingmastery': '/',
  '/grayarea': '/',
  '/home-annual-page': '/',
  '/idgaf': '/',
  '/jordan': '/',
  '/lex': '/',
  '/longform': '/',
  '/profg': '/',
  '/search': '/',
  '/thank-you-setup': '/',
  '/three-week-trial': '/',
  '/unexplainable': '/',
  '/apply': '/',
  '/setup-extension': '/browser-extension',
  '7-day-trial': '/',
};

const s3OnlyRedirects: Record<string, string> = {
  '/setup-extension.html': '/browser-extension',
  '/delete-data/setup-extension.html': '/browser-extension',
  '/detail_learn/setup-extension.html': '/browser-extension',
  '/apply/setup-extension.html': '/browser-extension',
  '/password-reset/setup-extension.html': '/browser-extension',
  '/password-successfully-reset/setup-extension.html': '/browser-extension',
  '/password-verify/setup-extension.html': '/browser-extension',
  '/blog/apps-for-students/grammarly.com': '/blog/apps-for-students/',
  '/terms.html': '/terms',
  '/privacy.html': '/privacy',
  '/privacy/setup-extension.html': '/browser-extension',
};

export const redirectServerFn = createServerFn()
  .validator(
    Schema.toStandardSchemaV1(
      Schema.Struct({
        pathname: Schema.String,
      }),
    ),
  )
  .handler(({ data }) => {
    const { pathname } = data;

    if (pathname in redirects) {
      throw redirect({ to: redirects[pathname] });
    }

    if (pathname in s3OnlyRedirects) {
      throw redirect({ to: s3OnlyRedirects[pathname] });
    }
  });
